import reduce from './reducers/index'
import * as Actions from './actions/actions'
import ResponseHandler from './message-handlers/response'
import { sendExtensibleRequest } from '@alme/ui-web/modules/lib-alme-request/src/lib-alme-request';
import {waitForIvaFunction} from '../lib-alight-library/lib-alight-library'
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';


export default class AccessKeyHandler {
    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;
    _accessKeyResponseHandler: ResponseHandler;

    constructor(settings: AlightCustomSettingsType){
        this._settings = settings;
        this._accessKeyResponseHandler = new ResponseHandler(settings);

    }   //  end constructor

    initialize(store: Store<AlmeState>){
        this._store = store;
    }   //  end initialize


    getReducer(){
        return reduce;
    }

    getResponseHandler(){
        return this._accessKeyResponseHandler;
    }

    getPromise(){
        if (this.shouldAct()) {
            return this.getAccessKey();
        }

        return Promise.resolve();
    }

    getAccessKey(){
        // convert to access key location, bail if we have access key saved
        //@ts-ignore
        let accessKey = this._store.getState()[this._settings.stateLocations.Conversation.Base][this._settings.stateLocations.Conversation.accessKey]
        if (accessKey !== undefined && accessKey !== null && accessKey !== ""){
            return Promise.resolve();
        }

        waitForIvaFunction().then((result) =>{
            if(result == true){
                if (window.enableIVAasService){
                    // Get  multitenant from ivaas
                    var initData = window.enableIVAasService();

                    if (initData===undefined || initData === null){
                        return Promise.resolve();
                    }

                    if (initData.multiTenantId)
                    {
                        initData.multiTenantId = this.normalizeMultitenantId(initData.multiTenantId);
                        return this.processAccessKey(initData.multiTenantId);
                    }
                }
                else{
                    if (window.enableIVA2Features){
                        // Get  multitenant from payload
                        let productPayload = window.enableIVA2Features();
                        let accessKey = getAccessKeyFromPayload(
                            productPayload,
                            this._settings,
                            )
                        if(accessKey !== null && accessKey !== undefined){
                            productPayload.accessKey = accessKey;
                            let accessKeyLocation = `${this._settings.stateLocations.Conversation.Base}.${this._settings.stateLocations.Conversation.accessKey}`
                            let accessKeyInput = {
                                "accessKey": productPayload.accessKey,
                                "stateLocation":accessKeyLocation
                                }
                            this._store?.dispatch(Actions.saveAccessKey(accessKeyInput));
                        }
                        else{
                            return this.processMultitenantIdFromPayload(productPayload, this._settings)
                        }
                    }
                    return Promise.resolve();
                }
            }
            return Promise.resolve();
        });
    }

    normalizeMultitenantId(originalId: string){
        return originalId.split("_")[0];
    }

    processMultitenantIdFromPayload(productPayload: any, settings: AlightCustomSettingsType){
        let configData = productPayload.generalConfigData || {};

        return getAccessKey(this.normalizeMultitenantId(configData.multiTenantId), settings);
    }

    processAccessKey(multiTenantId: string){
        let accessKeyPromise = getAccessKey(
            multiTenantId,
            this._settings,
        )

        return accessKeyPromise;
    }

    shouldAct()
    {
        return true;
    }

}

function getAccessKeyFromPayload(productPayload: any, settings: AlightCustomSettingsType) {
    let configData = productPayload.generalConfigData || {};
    // If accessKey is provided directly, just use that instead of looking it up.
    // (This allows the client to start doing that in the future w/o a code change).
    let accessKey = configData.accessKey;
    if (accessKey) {
        return accessKeyOrDefault(accessKey);
    }

    return null;
}

async function getAccessKey(multiTenantId: string, settings: AlightCustomSettingsType){
    let url = settings.ExtensibleAlmeAPI.EntitlementEndpoint.replace('{id}', multiTenantId);
    const input = {
        parameters: {},
        messageType: settings.messageConstants.extensibleRequest,
        messageSource: settings.initializationData.accessKeyMessageSourceName,
        endpoint: url
    };

    await sendExtensibleRequest(input, 'GET')
}

function accessKeyOrDefault(accessKey: string) {
    return (
        typeof accessKey === 'string' &&
        /^[A-Z0-9]{8}\-[A-Z0-9]{4}\-[A-Z0-9]{4}\-[A-Z0-9]{4}\-[A-Z0-9]{12}$/i.test(accessKey)
    ) ? accessKey : '00000000-0000-0000-0000-000000000000';
}


// WEBPACK FOOTER //
// ./modules/access-key-processor/access-key-processor.ts